<template>
    <span
        class="text-succesx float-left mr-1"
        v-if="convenio.idSituacaoConvenio != 9"
    >
        <i
            class="fa fa-times fa-lg icon-button"
            title="Glosar Prestação"
            @click.stop="confirmarGlosar()"
        ></i>
    </span>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'

export default {
    props: {
        convenio: Object,
        prestacaoContasFinalLancamento: Object
    },

    methods: {
        confirmarGlosar() {
            this.$swal({
                title: 'Glosar',
                html: 'Deseja Glosar a Prestação? ',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: `Informe a Justificativa`,
                inputValidator: (value) => {
                    if (!value) {
                        return `A justificativa é obrigatória'`
                    }
                }
            }).then((result) => {
                if (result.value) {
                    this.glosar(result.value)
                }
            })
        },

        glosar(justificativa) {
            this.$store.dispatch('addRequest')
            this.prestacaoContasFinalLancamento.justificativaGlosar =
                justificativa
            ConveniosServicos.glosarPrestacaoContasFinal(
                this.prestacaoContasFinalLancamento
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Lançamento Glosado com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                        this.$emit('ocorreuAlteracao')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
